import { render, staticRenderFns } from "./ResearchAnnotationsPlotV2.vue?vue&type=template&id=687e09ee&"
import script from "./ResearchAnnotationsPlotV2.vue?vue&type=script&lang=js&"
export * from "./ResearchAnnotationsPlotV2.vue?vue&type=script&lang=js&"
import style0 from "./ResearchAnnotationsPlotV2.vue?vue&type=style&index=0&id=687e09ee&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687e09ee')) {
      api.createRecord('687e09ee', component.options)
    } else {
      api.reload('687e09ee', component.options)
    }
    module.hot.accept("./ResearchAnnotationsPlotV2.vue?vue&type=template&id=687e09ee&", function () {
      api.rerender('687e09ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchAnnotationsPlotV2.vue"
export default component.exports